import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { searchInitialState, suggestSongInitialState } from './constants';
import { fetchSongsSuggestion } from './thunks';

const searchSlice = createSlice({
  name: 'search',
  initialState: searchInitialState,
  reducers: {
    saveInputValue: (state, action: PayloadAction<string>) => {
      state.inputValue = action.payload;
    },
    resetSuggestion: (state) => {
      state.suggestSong = suggestSongInitialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSongsSuggestion.pending, (state) => {
      state.suggestSong.loading = true;
    });
    builder.addCase(fetchSongsSuggestion.rejected, (state) => {
      state.suggestSong.error = true;
    });
    builder.addCase(fetchSongsSuggestion.fulfilled, (state) => {
      state.suggestSong.processed = true;
    });
  },
});

export const { saveInputValue, resetSuggestion } = searchSlice.actions;

export default searchSlice.reducer;
